import * as PIXI from 'pixi.js';
import GSOParasite from '../../../Game/Base/GSOParasite';
import Global from '../../../Game/Global';
import Vector from '../../../Game/Base/Math/Vector';
import CanvasBlokButton from '../../CanvasBlokButton';
import { Shape } from '../../../Game/Level/Blok';

export default class HoverBlokOverlay extends GSOParasite {
    constructor(realParent, stepParent) {
        super(realParent, stepParent);

        this.pixiContainer = null;
        this.pixiGraphics = null;

        this.blockDrag = new CanvasBlokButton(this);
        this.blockDrag.zIndex = -1;
        this.blockDrag.onMouseDown = function(mousePositionP) {
            if (realParent.selectingBlokForActieReactie || !realParent.inStateMode) {
                return;
            }

            const mousePosition = this.getGame().canvasToGamePosition(mousePositionP);
            this.dragOffset = new Vector(0, 0);
            this.dragOffset.x = this.blok.position.x - mousePosition.x;
            this.dragOffset.y = this.blok.position.y - mousePosition.y;

            if (!this.blok.isPlayer) {
                this._gsoParent._realParent.blokManager.putBlokAtTop(this.blok);
                this._gsoParent._realParent.selectedBlokOverlay._gsoDestroyVisuals();
            } else {
                this._gsoParent._realParent.setSelectedBlok(null);
            }
        };
        this.blockDrag.onMouseMove = function(mousePositionP) {
            if (realParent.selectingBlokForActieReactie || !realParent.inStateMode) {
                return;
            }

            const game = this.getGame();
            const mousePosition = game.canvasToGamePosition(mousePositionP);
            this.blok.position.x = Math.round(mousePosition.x + this.dragOffset.x);
            this.blok.position.y = Math.round(mousePosition.y + this.dragOffset.y);

            if (game.keys.Shift || game.keys.ShiftLeft || game.keys.ShiftRight) {
                this.blok.position.x = Math.round(this.blok.position.x / (Global.NATIVE_BLOCK_SIZE / 2)) * (Global.NATIVE_BLOCK_SIZE / 2);
                this.blok.position.y = Math.round(this.blok.position.y / (Global.NATIVE_BLOCK_SIZE / 2)) * (Global.NATIVE_BLOCK_SIZE / 2);
            } else if (game.keys.Control || game.keys.ControlLeft || game.keys.ControlRight) {
                this.blok.position.x = Math.round(this.blok.position.x / (Global.NATIVE_BLOCK_SIZE / 8)) * (Global.NATIVE_BLOCK_SIZE / 8);
                this.blok.position.y = Math.round(this.blok.position.y / (Global.NATIVE_BLOCK_SIZE / 8)) * (Global.NATIVE_BLOCK_SIZE / 8);
            }
        };
        this.blockDrag.onMouseUp = function() {
            if (!this.blok.isPlayer) {
                if (realParent.selectingBlokForActieReactie) {
                    realParent.selectActionReactionForward(this.blok);
                    return;
                }
                if (!realParent.inStateMode) return;

                if (this._gsoParent._realParent.getSelectedBlok()) {
                    this._gsoParent._realParent.selectedBlokOverlay._gsoCreateVisuals();
                    this._gsoParent._realParent.selectedBlokOverlay._gsoUpdateVisuals();
                }
                this._gsoParent._realParent.setSelectedBlok(this.blok);
            }
        };
    }

    onMouseDown() {
        this._realParent.setSelectedBlok(this.getAttachedStepParent());
    }

    onCreateVisuals() {
        this.pixiContainer = new PIXI.Container();
        this.getParentPixiContainer().addChild(this.pixiContainer);

        this.pixiGraphics = new PIXI.Graphics();
        this.pixiContainer.addChild(this.pixiGraphics);
    }

    onUpdateVisuals() {
        const blok = this.getAttachedStepParent();

        this.pixiGraphics.clear();
        if (this.blockDrag.state !== 0) {
            const lineThickness = 3;
            if (this.blockDrag.state === 1) {
                this.pixiGraphics.lineStyle(lineThickness + 0.1, 0x38c92b);
            } else this.pixiGraphics.lineStyle(lineThickness + 0.1, 0x152227);

            if (blok.shape === Shape.rectangle) {
                this.pixiGraphics.drawRect(
                    (-blok.size.x * Global.NATIVE_BLOCK_SIZE) / 2 + lineThickness / 2,
                    (-blok.size.y * Global.NATIVE_BLOCK_SIZE) / 2 + lineThickness / 2,
                    blok.size.x * Global.NATIVE_BLOCK_SIZE - lineThickness,
                    blok.size.y * Global.NATIVE_BLOCK_SIZE - lineThickness
                );
            } else {
                this.pixiGraphics.drawCircle(0, 0, (blok.size.x * Global.NATIVE_BLOCK_SIZE - lineThickness) / 2);
            }
        }
        if (this.blockDrag.state === 1 && this._realParent.getSelectedBlok() === blok) this.pixiGraphics.clear();
    }

    onDestroyVisuals() {
        this.pixiGraphics.destroy();
        this.pixiContainer.destroy();
    }

    onAttach() {
        this.blockDrag.blok = this.getAttachedStepParent();
    }

    onDetach() {
        this.blockDrag.blok = null;
    }
}
